import { Component } from '@angular/core';
import { HasSubscriptions } from '../../has-subscriptions';
import { AnalyticsService } from '../../../services/analytics/analytics.service';
import { HOMEPAGE_OFFMARKET_SEARCH } from '../../../classes/analytics-tags';

@Component({
  selector: 'app-estimate-cta',
  templateUrl: './estimate-cta.component.html',
  styleUrls: ['./estimate-cta.component.scss']
})
export class EstimateCtaComponent {
  constructor(protected _analyticsService: AnalyticsService)
  {
  }
    onNavigate(){
      this._analyticsService.eventTrack(HOMEPAGE_OFFMARKET_SEARCH, null);
    }
}
